import QuickActionsVM from './quick-actions-vm';
import GradesVM from './grades-vm';
import SummaryVM from './summary-vm';
import AnalyticsVM from './analytics-vm';

export default function () {
  var self = this;
  self.activeTab = ko.observable();
  self.ungraded = ko.observable(null);
  self.quick_actions = null;
  self.grades = null;
  self.summary = null;
  self.analytics = null;

  self.initUI = function() {
  };

  self.refreshURL = function () {
    var url = Kadenze.Routes.course_gradebook_overview_path(self.course_id, {sheet: self.activeTab()});
    history.replaceState($.pjax.state, null, url);
  };

  self.initQuickActions = function() {
    self.quick_actions = new QuickActionsVM();
    ko.applyBindingsWithValidation(self.quick_actions, self.quick_actions.$el[0], Kadenze.Knockout.DEFAULT_VALIDATION_OPTIONS);
  };

  self.initSpreadsheet = function() {
    if (self.activeTab() == 'grades' && self.grades == null) {
      self.grades = new GradesVM();
      ko.applyBindingsWithValidation(self.grades, self.grades.$el[0], Kadenze.Knockout.DEFAULT_VALIDATION_OPTIONS);
    } else if (self.activeTab() == 'summary' && self.summary == null) {
      self.summary = new SummaryVM();
      ko.applyBindingsWithValidation(self.summary, self.summary.$el[0], Kadenze.Knockout.DEFAULT_VALIDATION_OPTIONS);
    } else if (self.activeTab() == 'analytics' && self.analytics == null) {
      self.analytics = new AnalyticsVM();
      ko.applyBindingsWithValidation(self.analytics, self.analytics.$el[0], Kadenze.Knockout.DEFAULT_VALIDATION_OPTIONS);
    }
    self.refreshURL();
  };

  self.showTab = function (tab) {
    self.activeTab(tab);
    var tabId = '#{name}-tab'.supplant({name: tab});
    var $el = $(tabId);
    $el.tab('show');
  };

  self.activeVM = function () {
    return self[self.activeTab()];
  };

  self.exportTable = function (item, event) {
    var vm = self.activeVM();
    vm && vm.exportTable();
    event.stopPropagation();
  };

  const __construct = function(that) {
    console.log('constructor called for InstructorGradebook.OverviewViewModel');
    that.course_id = $('#course_id').val();

    that.initQuickActions();

    //Update spreadsheet if active sheet changes
    var sheet = Kadenze.Util.getParameterByName('sheet');
    that.activeTab.subscribe(that.initSpreadsheet);
    that.showTab(sheet || 'grades');
  }(this);
}

